import React from "react";

import Typography from "../../../Typography";

import "./dealing-tag.css";

export default function DealingTag({ type, value, NpsNote, dealStatusId }) {
    let color, label;

    if (NpsNote >= 0 && NpsNote <= 6) {
        color = "#C90000";
        label = "Detrator";
    } else if (NpsNote === 7 || NpsNote === 8) {
        color = "#F2BD00";
        label = "Neutro";
    } else if (NpsNote === 9 || NpsNote === 10) {
        color = "#008908";
        label = "Promotor";
    }

    if (type === "profile") {
        return (
            <div className="profile-tag-container">
                <div
                    className="profile-tag-content"
                    style={{ background: color }}
                >
                    <span className="profile-tag-content__span" />

                    <Typography.H5 weight="500" color="white">
                        {label}
                    </Typography.H5>
                </div>
            </div>
        );
    } else {
        if (
            (value.desc_deal_status === null || value.desc_deal_status === "Novo") &&
            (value.id_deal_status === null || value.id_deal_status === 1)
        ) {
            color = "#455cc7";
            label = "Novo";
        }else{
            color = value.class_color;
            label = value.desc_deal_status;
        }

        return (
            <div className="status-tag-container">
                <div
                    className="status-tag-content"
                    style={{ background: color }}
                >
                    <span className="status-tag-content__span" />

                    <Typography.H5 weight="500" color="white">
                        {label}
                    </Typography.H5>
                </div>
            </div>
        );
    }
} 
